const reviewWorkflow = `
### Why every fact needs a review

Facts are extracted by AI from the source documents. Extraction can attach a value to the wrong patient or invent one. Reviewing each fact and its citation is the safety net before anything flows into the reports. The Generate Documents button does not appear until the review is complete.

### Mark each fact

Each fact card shows the field, the extracted answer, and two buttons.

- Correct marks the fact as verified. The button then reads Uncheck.
- Modify turns the answer into a text box so you can fix it. A modified fact is unverified until you mark it Correct again.
- View citation shows the quoted text below the fact, with the document name and page number.

A fact that reads Information not found means the model did not find it in the documents. Leave it if that is right, or click Modify and enter the value.

Facts are grouped. Each group header shows how many facts in it are verified, and a finished group folds closed on its own.

### Timeline events

Cases with a care timeline show a Timeline tab beside Facts. Confirm or Dismiss each event, or click Confirm all. The Status menu on an event sets it to Active, Completed, Discontinued, or Unknown. Every active event must be confirmed or dismissed before documents can be generated.

### Patient identity banner

If the documents may belong to different patients, a banner titled Patient identity mismatch lists each document with the name, date of birth, and MRN it carries. Click Same patient if they match. Click Different patients if they do not, then use Go to files to remove the files that belong to someone else and run the extraction again. Documents cannot be generated while this banner is unresolved.

### Generate the documents

When every fact is verified and every timeline event is reviewed, the Generate Documents button appears. On a case that already has documents the button reads Regenerate Documents, and the app asks you to confirm because regeneration replaces the existing documents.

Changing any fact after generation marks the documents as out of date. A banner on the Documents step tells you to regenerate them from Review & Approve.

### Processing warnings

If a step of the pipeline fails, a banner reads One processing step needs attention, or gives the count. It names the step, for example Red flags or Extraction with a group name. The case owner or a facility admin can click Retry failed steps.

### Start over

Re-extract Medical Information on the Upload & Manage step erases all extracted facts, your verifications, and the generated documents. Removing a document also requires the extraction to run again. Both actions ask for confirmation.
`;

export default reviewWorkflow;
